import Stack from 'app/components/base/Stack'
import FiltersButton from 'app/components/buttons/FiltersButton'
import useModal from 'app/hooks/useModal'
import useProductsFiltersControl from 'app/hooks/useProductsFiltersControl'

import ProductsFilterDialog from './ProductsFilterDialog'

const ProductsMobileFilter: RFC<{ partNumbers?: string[] }> = ({
  partNumbers
}) => {
  const { open, hideModal, showModal } = useModal()
  const { hasFilters } = useProductsFiltersControl<UserListingsParams>()

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'flex', md: 'none' },
        width: '100%',
        justifyContent: 'space-between'
      }}
    >
      <FiltersButton hideBadge={hasFilters} onClick={showModal} />

      {open && (
        <ProductsFilterDialog
          open={open}
          onClose={hideModal}
          partNumbers={partNumbers}
        />
      )}
    </Stack>
  )
}

export default ProductsMobileFilter
